<script setup>
import {envs} from "@/main/envs";
import DarkHome from "@/themes/dark/views/DarkHome.vue";

let HomeView;

switch (envs.theme) {
  case 'dark':
  default:
    HomeView = DarkHome; break;
}

</script>

<template>
  <home-view/>
</template>
